import { render } from "./Price.vue?vue&type=template&id=70863a72&scoped=true"
import script from "./Price.vue?vue&type=script&lang=js"
export * from "./Price.vue?vue&type=script&lang=js"

import "./Price.vue?vue&type=style&index=0&id=70863a72&scoped=true&lang=css"

import exportComponent from "/Users/Apple/Desktop/projects/guguop/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70863a72"]])

export default __exports__